import Vue from 'vue'
import axios from 'axios'
axios.defaults.timeout = 10000;
axios.interceptors.request.use(config=> {
  return config;
}, err=> {
    Vue.$vux.toast.text('请求出错!', 'middle');  
    return Promise.resolve(err);
})
axios.interceptors.response.use(data=> {//响应拦截
//  console.log(data)    
  return data;
}, err=> {
    
  if(err.message=='Network Error'||!err.response){
     Vue.noMore = true
     Vue.$vux.toast.text('网络断开，请检查你的网络', 'middle'); 
      
  }else if(err.response.status == 504){
      Vue.$vux.loading.hide()
      Vue.$vux.toast.text('请求超时⊙﹏⊙∥', 'middle'); 
  }else if(err.response.status == 404) {
      Vue.$vux.toast.text('网页被吃了⊙﹏⊙∥', 'middle');  
  } else if (err.response.status == 403) {
      Vue.$vux.toast.text('权限不足,请联系管理员!', 'middle');  
  }else {
      Vue.$vux.toast.text('未知错误', 'middle');  
  }
  return Promise.resolve(err);
})
//开发
let base = '/ytqmmc';
//测试
//let base = '/cmsone';
//登录
export const  reg = params => {
//	params = qs.stringify(params);
	return axios.post(`${base}/v1/member/reg.thtml`,params).then( res => res.data);
}
export const  login = params => {//注册
//	params = qs.stringify(params);
	return axios.post(`${base}/v1/member/login.thtml`,params).then( res => res.data);
}
export const  send_code = params => {//发送验证码
//	params = qs.stringify(params);
//    console.log(typeof params)
//     console.log(params)
	return axios.post(`${base}/v1/sms/send_code.thtml`,params).then( res => res.data);
}
export const  edit = params => {//修改个人信息
//	params = qs.stringify(params);
//    console.log(typeof params)
//     console.log(params)
	return axios.post(`${base}/v1/member/edit.thtml`,params).then( res => res.data);
}
export const  index = params => {//首页
//     console.log(params)
	return axios.post(`${base}/v1/qmmc/index.thtml `,params).then( res => res.data);
}
export const  shareTaskIndexList = params => {//首页任务列表
//     console.log(params)
	return axios.post(`${base}/v1/shareTask/index_list.thtml`,params).then( res => res.data);
}
export const  detail = params => {//产品详情页
//     console.log(params)
	return axios.post(`${base}/v1/qmmc/product/detail.thtml`,params).then( res => res.data);
}
export const  save = params => {//生成海报
//     console.log(params)
	return axios.post(`${base}/v1/memberProductPost/save.thtml`,params,{timeout: 1000 * 60 * 1}).then( res => res.data);
}
export const  create = params => {//推荐
//     console.log(params)
	return axios.post(`${base}/v1/memberRecommendBuy/create.thtml`,params).then( res => res.data);
}
export const  list = params => {//分类
//     console.log(params)
	return axios.post(`${base}/v1/qmmc/product-category/list.thtml `,params).then( res => res.data);
}
export const  simpleList = params => {//列表简易接口
//     console.log(params)
	return axios.post(`${base}/v1/qmmc/product/simple-list.thtml `,params).then( res => res.data);
}
export const  posterList = params => {//海报列表接口
//     console.log(params)
	return axios.post(`${base}/v1/memberProductPost/list.thtml`,params).then( res => res.data);
}
export const  recommendBuyList = params => {//推荐购车列表
//     console.log(params)
	return axios.post(`${base}/v1/memberRecommendBuy/list.thtml `,params).then( res => res.data);
}
export const  recommendBuyDetail = params => {//进度详情
//     console.log(params)
	return axios.post(`${base}/v1/memberRecommendBuy/detail.thtml`,params).then( res => res.data);
}

export const  search = params => {//产品筛选
//     console.log(params)
	return axios.post(`${base}/v1/qmmc/product/search.thtml`,params).then( res => res.data);
}
export const  modelfields = params => {//产品参数
//     console.log(params)
	return axios.post(`${base}/v1/qmmc/product-modelfields/list.thtml`,params).then( res => res.data);
}
export const  count = params => {//产品详情统计(uvid)
//     console.log(params)
	return axios.post(`${base}/v2/memberProductPost/count.thtml `,params).then( res => res.data);
}
export const  countByOpenid = params => {//产品详情统计(openid)
//     console.log(params)
	return axios.post(`${base}/v2/memberProductPost/countByOpenid.thtml `,params).then( res => res.data);
}
export const  noticeDetail = params => {//公告详情
//     console.log(params)
	return axios.post(`${base}/v1/notice/detail.thtml`,params).then( res => res.data);
}
export const  getMemberAsset = params => {//获取用户资产
//     console.log(params)
	return axios.post(`${base}/v1/memberAssetRecord/getMemberAsset.thtml`,params).then( res => res.data);
}
export const  putForward = params => {//提现
//     console.log(params)
	return axios.post(`${base}/v1/memberAssetRecord/putForward.thtml`,params).then( res => res.data);
}
export const  assetRecordList = params => {//提现记录
//     console.log(params)
	return axios.post(`${base}/v1/memberAssetRecord/list.thtml`,params).then( res => res.data);
}
export const  memberAdviceCreate = params => {//提现记录
//     console.log(params)
	return axios.post(`${base}/v1/memberAdvice/create.thtml`,params).then( res => res.data);
}
export const  shareTaskList = params => {//分享列表
//     console.log(params)
	return axios.post(`${base}/v1/shareTask/list.thtml`,params).then( res => res.data);
}
export const  memberShareTaskList = params => {//我的分享列表
//     console.log(params)
	return axios.post(`${base}/v1/memberShare/list.thtml`,params).then( res => res.data);
}
export const  memberShareCreate = params => {//创建分享
//     console.log(params)
	return axios.post(`${base}/v1/memberShare/create.thtml`,params).then( res => res.data);
}
export const  memberShareCount = params => {//分享统计，积分计算(uvid)
//     console.log(params)
	return axios.post(`${base}/v1/memberShare/count.thtml`,params).then( res => res.data);
}
export const  memberShareCountByOpenid = params => {//分享统计，积分计算(openid)
//     console.log(params)
	return axios.post(`${base}/v1/memberShare/countByOpenid.thtml`,params).then( res => res.data);
}
export const  taskDetail = params => {//分享任务详情
//     console.log(params)
	return axios.post(`${base}/v1/shareTask/detail.thtml`,params).then( res => res.data);
}
export const  getMemberPoint = params => {//获取用户积分
//     console.log(params)
	return axios.post(`${base}/v1/memberPoint/getMemberPoint.thtml`,params).then( res => res.data);
}

export const  pointRecordList = params => {//积分记录
//     console.log(params)
	return axios.post(`${base}/v1/memberPointRecord/list.thtml`,params).then( res => res.data);
}
export const  productParameter = params => {//海报分享记录
//     console.log(params)
	return axios.post(`${base}/v1/qmmc/product/product_parameter.thtml`,params).then( res => res.data);
}

//export const  send_code = params => {//发送验证码
////	params = qs.stringify(params);
//    console.log(typeof params)
//     console.log(params)
//	return axios.post(`${base}/v1/sms/send_code.thtml`,params).then( res => res.data);
//}




// WEBPACK FOOTER //
// ./src/base/js/api.js